export default "__VITE_ASSET__b44c079e__";